"use client";
import React, { useEffect, useRef, useState } from "react";
import HeroMainBanner from "./Layout5Hero2Components/HeroMainBanner";
import HeroFeaturedCollections from "./Layout5Hero2Components/HeroFeaturedCollections";
import HeroBottomBanner from "./Layout5Hero2Components/HeroBottomBanner";
export default function HeroVideo2_Layout5({ data }: any) {
  const videoRefs = useRef<(HTMLVideoElement | null)[]>([]);
  const [isMuted, setIsMuted] = useState(true);
  const [isDesktop, setIsDesktop] = useState(false);
  const bannerMediaData = data?.videos?.[0] || null;
  const mediaSources = data?.videos || [];

  const isVideo = (media: any) => {
    if (!media) return false;
    const src = media.videoSource || media.imageSource || "";
    return (
      src.toLowerCase().endsWith(".mp4") ||
      src.toLowerCase().endsWith(".webm") ||
      src.toLowerCase().endsWith(".ogg")
    );
  };
  const getMediaSource = (media: any) =>
    media?.videoSource || media?.imageSource || "";

  useEffect(() => {
    const checkIsDesktop = () => setIsDesktop(window.innerWidth >= 1024);
    checkIsDesktop();
    window.addEventListener("resize", checkIsDesktop);
    videoRefs.current.forEach((v) => v && v.play().catch(() => {}));
    return () => window.removeEventListener("resize", checkIsDesktop);
  }, []);

  return (
    <section className="relative w-full bg-[var(--secondary-lightest)] overflow-hidden">
      <HeroMainBanner
        data={data}
        bannerMediaData={bannerMediaData}
        isDesktop={isDesktop}
        isMuted={isMuted}
        videoRefs={videoRefs}
        isVideo={isVideo}
        getMediaSource={getMediaSource}
      />
    </section>
  );
}
